<template>

	<!-- Page Header -->
	<div class="page-header page-header-light shadow">
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getVociPreferite()">Contabilità</a>
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1">Voci Preferite</span>
				</h4>
				<a href="#page_header_vp" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header_vp">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('VOCI_PREFERITE_CREATE')" v-on:click="nuovaVocePreferita()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0"><Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Voce Preferita</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>
					<div class="vr flex-shrink-0 my-2 mx-3"></div>
					<div class="d-inline-flex float-end mt-sm-0">
						<a v-if="$root.hasFunzionalita('CONF_VOCI_PREFERITE_READ')" href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(64)" title="Configurazione Voci Preferite" data-bs-toggle="tooltip" data-bs-placement="left"><i class="ph-lightning"></i></a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(64)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left"><i class="ph-flag"></i></a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(64)" title="Help OnLine" data-bs-toggle="tooltip" data-bs-placement="left"><i class="icon-question7 pink"></i></a>
					</div>
				</div>
			</div>
		</div>

		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#vocip-tab" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-star"></i>
								<span class="hidden-lg ms-1">Voci Preferite</span>
								<span class="hidden-xs ms-1">Elenco Voci Preferite</span>
							</div>
						</a>
					</li>
				</ul>
				<div class="page-header-content d-lg-flex">
					<div class="d-flex">
						<a href="#page_header_vp_nav" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
							<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
						</a>
					</div>
					<div id="page_header_vp_nav" class="collapse d-lg-block ms-lg-auto mt-2 mt-lg-0">
						<div class="d-flex gap-2 align-items-center flex-wrap">
							<button class="btn btn-primary btn-sm" @click="getVociPreferite()">
								<i class="ph-arrows-clockwise me-1"></i> AGGIORNA
							</button>
						</div>
					</div>
				</div>
				<div class="navbar-collapse collapse" id="vocip_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item">
											<i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_UPDATE')" @click.prevent="attivaSelezionati()">
												<i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati
											</a>
											<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_UPDATE')" @click.prevent="disattivaSelezionati()">
												<i class="far fa-square fa-fw me-2"></i>Disattiva selezionati
											</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start" v-if="$root.hasFunzionalita('VOCI_PREFERITE_EXPORT')">
										<a href="#" class="dropdown-item">
											<i class="far fa-file-export fa-fw me-2"></i>
											<span class="text-muted me-1">|</span>Esporta dati
										</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('pagina')">
												<i class="far fa-file-export fa-fw me-2"></i>Pagina corrente
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('selezionati')">
												<i class="far fa-file-export fa-fw me-2"></i>Voci selezionate
											</a>
											<a href="#" class="dropdown-item" @click.prevent="apriEsportazione('tutti')">
												<i class="far fa-file-export fa-fw me-2"></i>Tutte le voci
											</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('VOCI_PREFERITE_DELETE')" @click.prevent="eliminaSelezionati()">
										<i class="far fa-trash fa-fw me-2 text-danger"></i>
										<span class="text-muted me-1">|</span>Elimina selezionati
									</a>
									<a href="#" class="dropdown-item" @click.prevent="eliminaDefinitivamenteSelezionati()" v-if="$root.isGod">
										<i class="far fa-trash-alt fa-fw me-2 text-danger"></i>
										<span class="text-muted me-1">|</span>Elimina definitivamente selezionati
									</a>
									<a href="#" class="dropdown-item" @click.prevent="ripristinaSelezionati()" v-if="$root.isGod && arrayVociPreferite.some(v => v.SELEZIONATO == 1 && v.FLG_ELIMINATO == 1)">
										<i class="far fa-redo fa-fw me-2 text-success"></i>
										<span class="text-muted me-1">|</span>Ripristina selezionati
									</a>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
	<!-- /Page Header -->

	<div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">
			<div class="tab-pane fade active show" id="vocip-tab">

	<div class="card shadow mb-xs-3 mb-lg-0">
		<div class="card-body pb-0">
			<div class="alert alert-2 alert-secondary border-0">
				<div class="row">
					<div class="col-md-4 mbx-1">
						<input autocomplete="off" class="form-control form-control-sm" type="text"
							placeholder="Cerca titolo..." v-model="searchVociPreferite.TITOLO.VALUE" />
					</div>
					<div class="col-md-2 mbx-1">
						<Select2 v-model="searchVociPreferite.FK_ID_AZIENDA.VALUE" :api="'theb-s2/agenzie'"
							:apiselected="'theb-s2/agenzie/selected?a=1'" :placeholder="'Cliente'"></Select2>
					</div>
					<div class="col-md-2 mbx-1">
						<Select2 v-model="searchVociPreferite.FK_ID_AZIENDA_FORNITORE.VALUE" :api="'theb-s2/fornitori'"
							:apiselected="'theb-s2/fornitori/selected'" :placeholder="'Fornitore'"></Select2>
					</div>
					<div class="col-md-2 mbx-1" v-if="$root.isGod">
						<select class="form-select form-select-sm" v-model="searchVociPreferite.FLG_ATTIVO.VALUE">
							<option value="">Tutti</option>
							<option value="1">Attive</option>
							<option value="0">Disattivate</option>
						</select>
					</div>
					<div class="col-md-2 mbx-1" v-if="$root.isGod">
						<select class="form-select form-select-sm" v-model="searchVociPreferite.FLG_ELIMINATO.VALUE">
							<option value="0">Non eliminate</option>
							<option value="">Tutte</option>
							<option value="1">Eliminate</option>
						</select>
					</div>
				</div>
			</div>
		</div>

		<div class="card-body box-card mt-0 mb-0">
			<div class="div_table_resp tableFixHead">
				<table class="table table-bordered table-hover table-striped text-nowrap">
					<thead class="sticky-top thead-bordered">
						<tr class="bg-secondary text-white">
							<th class="table-head-sm text-center" style="width:3%;" rowspan="2">
								<input id="chkAllVociPreferite" type="checkbox"
									v-on:click="filters.selectAll('chkAllVociPreferite', paginatedListVociPreferite.arr)">
							</th>
							<th class="table-head-sm text-center" style="width:3%;" rowspan="2">#</th>
							<th class="table-head-sm text-center" style="width:30%;" rowspan="2"><Translate :path="'dizionario.base.TITOLO'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'TITOLO'"></ISort></th>
							<th class="table-head-sm text-center" style="width:26%;" colspan="4"><Translate :path="'dizionario.attivita.VENDITA'"></Translate></th>
							<th class="table-head-sm text-center text-yellow" style="width:28%;" colspan="4"><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></th>
							<th v-if="$root.isGod" class="table-head-sm text-center" style="width:4%;" rowspan="2">Attivo</th>
							<th class="table-head-sm text-center" style="width:5%;" rowspan="2"><Translate :path="'dizionario.base.AZIONI'"></Translate></th>
						</tr>
						<tr class="bg-secondary text-white">
							<th class="table-head-sm text-center" style="width:4%;"><Translate :path="'dizionario.attivita.QUANTITA'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'QUANTITY_PRICE'"></ISort></th>
							<th class="table-head-sm text-center" style="width:4%;"><Translate :path="'dizionario.attivita.GIORNI'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'DAYS_PRICE'"></ISort></th>
							<th class="table-head-sm text-center" style="width:7%;"><Translate :path="'dizionario.attivita.PREZZO_UNIT'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'UNIT_PRICE'"></ISort></th>
							<th class="table-head-sm text-center" style="width:11%;"><Translate :path="'dizionario.attivita.TOTALE'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'TOTAL_PRICE'"></ISort></th>
							<th class="table-head-sm text-center text-yellow" style="width:7%;"><Translate :path="'dizionario.attivita.COSTO_UNIT'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'UNIT_COST_ESPOSTO'"></ISort></th>
							<th class="table-head-sm text-center text-yellow" style="width:7%;"><Translate :path="'dizionario.attivita.COSTI'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'TOTAL_COST_ESPOSTO'"></ISort></th>
							<th class="table-head-sm text-center text-yellow" style="width:7%;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'TOTAL_COST_PRIVATO'"></ISort></th>
							<th class="table-head-sm text-center text-yellow" style="width:7%;"><Translate :path="'dizionario.base.FORNITORE'"></Translate><ISort class="float-end" v-model="ordinamento" :campo="'AZIENDA_FORNITORE'"></ISort></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(vp, index) in paginatedListVociPreferite.arr" :key="vp.ID_VOCE_PREFERITA"
							:class="{ 'table-secondary text-muted': vp.FLG_ATTIVO == 0 || vp.FLG_DA_CALCOLARE == 0, 'table-danger text-muted': vp.FLG_ELIMINATO == 1 }"
							:style="vp.COLORE && vp.FLG_ELIMINATO != 1 ? { backgroundColor: vp.COLORE, color: vp.COLORE_TESTO || utils.getContrastColor(vp.COLORE) } : {}">
							<td class="table-head-sm text-center">
								<input type="checkbox"
									v-bind:true-value="1"
									v-bind:false-value="0"
									v-model="vp.SELEZIONATO" />
							</td>
							<td class="table-head-sm text-center"><small>{{ index + 1 }}</small></td>
							<td class="table-head-sm" style="word-wrap: break-word; white-space: normal;">
								<div v-if="vp.AZIENDA" class="text-muted" style="font-size:0.7rem;"><i class="ph-buildings me-1"></i>{{ filters.accorciaTesto(vp.AZIENDA, 50) }}</div>
								<i class="ph-file-text me-1 text-muted"></i><strong>{{ vp.TITOLO }}</strong>
								<span v-if="vp.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-1" style="font-size:0.6rem;"><Translate :path="'dizionario.attivita.ESCLUSA'"></Translate></span>
								<div v-if="vp.NOTE" class="text-muted small">{{ vp.NOTE }}</div>
							</td>
							<td class="table-head-sm text-end">{{ parseFloat(vp.QUANTITY_PRICE) }}</td>
							<td class="table-head-sm text-end">{{ parseFloat(vp.DAYS_PRICE) }}</td>
							<td class="table-head-sm text-end">
								<span v-if="vp.FLG_OMAGGIO_UNIT_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_PRICE }}</span>
							</td>
							<td class="table-head-sm text-end">
								<span v-if="vp.FLG_ESCLUDI_TOTALE_VENDITA == 1" class="text-muted" title="Non sommata nei totali">-</span>
								<span v-else-if="vp.FLG_OMAGGIO_UNIT_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
								<span class="text-primary fw-semibold">&euro; {{ vp.TOTAL_PRICE }}</span>
									<span v-if="vp.FLG_ESCLUDI_FEE_VENDITA == 1" class="badge bg-light text-body ms-1" style="font-size:0.65rem;" title="Esclusa dalla fee">No fee</span>
									<span v-if="vp.FLG_NETTO_IVA_VENDITA == 1" class="badge bg-light text-body ms-1" style="font-size:0.65rem;">Netto IVA</span>
									<span v-else-if="getIvaCode(vp.FK_ID_IVA_PREZZO)" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="getIvaCode(vp.FK_ID_IVA_PREZZO).DESCRIZIONE">{{ getIvaCode(vp.FK_ID_IVA_PREZZO).CUSTOM_1 }}</span>
								</template>
							</td>
							<td class="table-head-sm text-end">
								<span v-if="vp.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else class="text-muted" style="font-size:0.75rem;">&euro; {{ vp.UNIT_COST_ESPOSTO }}</span>
							</td>
							<td class="table-head-sm text-end">
								<span v-if="vp.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted" title="Non sommata nei totali">-</span>
								<span v-else-if="vp.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
								<span class="text-danger fw-semibold">&euro; {{ vp.TOTAL_COST_ESPOSTO }}</span>
									<span v-if="vp.FLG_NETTO_IVA_ACQUISTO == 1" class="badge bg-light text-body ms-1" style="font-size:0.65rem;">Netto IVA</span>
									<span v-else-if="getIvaCode(vp.FK_ID_IVA_COSTO)" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="getIvaCode(vp.FK_ID_IVA_COSTO).DESCRIZIONE">{{ getIvaCode(vp.FK_ID_IVA_COSTO).CUSTOM_1 }}</span>
								</template>
							</td>
							<td class="table-head-sm text-end">
								<span v-if="vp.FLG_ESCLUDI_TOTALE_ACQUISTO == 1" class="text-muted" title="Non sommata nei totali">-</span>
								<span v-else-if="vp.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1" class="badge bg-warning bg-opacity-20 text-warning" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-warning fw-semibold">&euro; {{ vp.TOTAL_COST_PRIVATO }}</span>
									<span v-if="vp.FLG_NETTO_IVA_COMMISSIONI == 1" class="badge bg-light text-body ms-1" style="font-size:0.65rem;">Netto IVA</span>
									<span v-else-if="getIvaCode(vp.FK_ID_IVA_COMMISSIONI)" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="getIvaCode(vp.FK_ID_IVA_COMMISSIONI).DESCRIZIONE">{{ getIvaCode(vp.FK_ID_IVA_COMMISSIONI).CUSTOM_1 }}</span>
								</template>
							</td>
							<td class="table-head-sm">
								<span v-if="vp.AZIENDA_FORNITORE" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(vp.AZIENDA_FORNITORE, 30) }}</span>
								<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
							</td>
							<td v-if="$root.isGod" class="table-head-sm text-center">
								<ISwitch
									:size="'xs'"
									:modelValue="vp.FLG_ATTIVO"
									@toggle="(val) => toggleFlgAttivo(vp, val)"
									title="Attivo/Disattivo"
								></ISwitch>
							</td>
							<td class="table-head-sm text-center">
								<div class="dropdown">
									<a href="#" class="text-body" data-bs-toggle="dropdown">
										<i class="ph-list"></i>
									</a>
									<div class="dropdown-menu dropdown-menu-end">
										<a href="#" class="dropdown-item" @click="modificaVocePreferita(vp)" v-if="vp.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCI_PREFERITE_UPDATE')">
											<i class="ph-pencil me-2"></i>Modifica
										</a>
										<a href="#" class="dropdown-item" @click="eliminaVocePreferita(vp)" v-if="vp.FLG_ELIMINATO != 1 && $root.hasFunzionalita('VOCI_PREFERITE_DELETE')">
											<i class="ph-trash text-danger me-2"></i>Elimina
										</a>
										<a href="#" class="dropdown-item" @click.prevent="eliminaDefinitivamenteVocePreferita(vp)" v-if="$root.isGod && vp.FLG_ELIMINATO == 1">
											<i class="ph-trash-simple text-danger me-2"></i>Elimina definitivamente
										</a>
										<a href="#" class="dropdown-item" @click.prevent="ripristinaVocePreferita(vp)" v-if="$root.isGod && vp.FLG_ELIMINATO == 1">
											<i class="ph-arrow-counter-clockwise text-success me-2"></i>Ripristina
										</a>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="row page-bottom">
				<div class="col-12 col-md-5 d-none d-sm-block">
					<div style="position: relative; top: 10px;">
						<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">VOCI
							PREFERITE: {{ paginatedListVociPreferite.count }}</span>
					</div>
				</div>
				<div class="col-9 col-md-6">
					<div class="float-end pag-mobile">
						<Pagine v-model="searchVociPreferite.PAGINATION.PAGE_NUMBER"
							:numrighe="paginatedListVociPreferite.count"
							:numpagine="searchVociPreferite.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
				</div>
				<div class="col-3 col-md-1">
					<select class="form-select form-select-sm wmin-100 mt-2 float-end"
						data-placeholder="Limite" :tabindex="20"
						v-model="searchVociPreferite.PAGINATION.PAGE_SIZE"
						style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
						<option value="75">75</option>
						<option value="100">100</option>
						<option value="250">250</option>
						<option value="500">500</option>
					</select>
				</div>
			</div>
		</div>
	</div>

			</div><!-- /tab-pane -->
		</div><!-- /tab-content -->
	</div><!-- /content -->

	<!-- Modale Voce Preferita -->
	<div class="modal fade" :id="'popUpVocePreferita' + rs" role="dialog" data-bs-backdrop="static">
		<div class="modal-dialog modal-xl">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white border-0 py-2">
					<h6 class="modal-title mb-0">
						<i class="ph-plus-circle me-2"></i>
						{{ $root.translate(vocePreferitaSelezionata.ID_VOCE_PREFERITA > 0 ? 'dizionario.base.BTN_MODIFICA' : 'dizionario.base.BTN_NUOVA') }} Voce Preferita
					</h6>
					<span v-if="bloccato" class="badge bg-warning text-dark ms-auto me-2"><i class="ph-lock me-1"></i>In modifica da {{ lock.USERNAME }} — sola lettura</span>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
				</div>
				<div class="modal-body p-3">
					<fieldset :disabled="bloccato">
					<div class="row mb-2">
						<div class="col-12 col-md-6">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.TITOLO'"></Translate> <span class="text-danger">*</span></label>
							<textarea class="form-control form-control-sm" v-model="vocePreferitaSelezionata.TITOLO"
								rows="7" placeholder="Inserisci il titolo della voce" style="resize: vertical;"></textarea>
						</div>
						<div class="col-12 col-md-6">
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.NOTE'"></Translate></label>
								<input type="text" class="form-control form-control-sm" v-model="vocePreferitaSelezionata.NOTE"
									placeholder="Inserisci eventuali note">
							</div>
							<div class="mb-2">
								<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.base.CLIENTE'"></Translate></label>
								<Select2 v-model="vocePreferitaSelezionata.FK_ID_AZIENDA" :api="'theb-s2/agenzie'"
									:apiselected="'theb-s2/agenzie/selected?a=1'" msg-inattivo="Cliente non attivo, attivalo prima di procedere"></Select2>
							</div>
							<div>
								<label class="form-label fw-semibold mb-1" style="width:100%;"><Translate :path="'dizionario.base.FORNITORE'"></Translate>
									<span class="badge bg-success badge-xs cursor-pointer float-end" @click="apriNuovoFornitore" title="Crea nuovo fornitore">{{ $root.translate('dizionario.base.BTN_NUOVA') }}</span>
								</label>
								<Select2 v-model="vocePreferitaSelezionata.FK_ID_AZIENDA_FORNITORE" :api="'theb-s2/fornitori'"
									:apiselected="'theb-s2/fornitori/selected'" msg-inattivo="Fornitore non attivo, attivalo prima di procedere"></Select2>
							</div>
						</div>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE'"></Translate></label>
							<ColorPicker v-model="vocePreferitaSelezionata.COLORE"></ColorPicker>
						</div>
						<div class="col-12 col-md-4 d-flex align-items-center gap-2 mt-2 mt-md-0">
							<label class="form-label fw-semibold mb-0 me-2"><Translate :path="'dizionario.attivita.INCLUDI_CALCOLO'"></Translate></label>
							<ISwitch v-model="vocePreferitaSelezionata.FLG_DA_CALCOLARE" style="z-index:0;"></ISwitch>
						</div>
					</div>

					<div class="row mb-2 align-items-end">
						<div class="col-12 col-md-8">
							<label class="form-label fw-semibold mb-1"><Translate :path="'dizionario.attivita.COLORE_TESTO'"></Translate></label>
							<div class="d-flex align-items-center gap-2">
								<div class="form-check form-switch mb-0">
									<input type="checkbox" class="form-check-input" v-model="coloreTestoAutomaticoVoce">
									<label class="form-check-label small"><Translate :path="'dizionario.attivita.COLORE_TESTO_AUTOMATICO'"></Translate></label>
								</div>
								<ColorPicker v-model="vocePreferitaSelezionata.COLORE_TESTO" :disabled="coloreTestoAutomaticoVoce"></ColorPicker>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-primary mb-1 mt-2"><i class="ph-currency-circle-dollar me-1"></i><Translate :path="'dizionario.attivita.VENDITA'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.QUANTITY_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.DAYS_PRICE" placeholder="1"
								@input="calcolaTotalePrezzo()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-costo-voce">
							<label class="form-label fw-semibold mb-1 text-nowrap" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO'"></Translate>
								<i class="ph-gift cursor-pointer float-end" :class="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'text-success' : 'text-muted'" @click="toggleOmaggio('UNIT_PRICE')" :title="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? 'Omaggio attivo: clicca per disattivare' : 'Clicca per impostare come omaggio'"></i>
							</label>
							<div class="position-relative">
								<input type="number" step="0.01" class="form-control form-control-sm" v-model.number="vocePreferitaSelezionata.UNIT_PRICE"
									placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1"
									@input="calcolaTotalePrezzo()"
								@blur="vocePreferitaSelezionata.UNIT_PRICE = parseFloat(vocePreferitaSelezionata.UNIT_PRICE || 0).toFixed(2)">
						</div>
						</div>
						<div class="col-6 col-iva-voce">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA'"></Translate></label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_PREZZO" :disabled="vocePreferitaSelezionata.FLG_NETTO_IVA_VENDITA == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1 text-nowrap" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA'"></Translate> ({{ ivaModaleSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaModaleSommario.importo" disabled>
						</div>
						<div class="col-6 col-md-2">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="vocePreferitaSelezionata.FLG_NETTO_IVA_VENDITA == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_CON_IVA'"></Translate></label>
							<div class="position-relative">
							<input type="text" class="form-control form-control-sm bg-light text-primary fw-bold"
									:value="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_PRICE == 1 ? $root.translate('dizionario.attivita.OMAGGIO') : ivaModaleSommario.totale" readonly>
						</div>
							</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_ESCLUDI_TOTALE_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Non sommare: la vendita resta visibile ma non entra nei totali di attività e progetto"
									@click="toggleFlag('FLG_ESCLUDI_TOTALE_VENDITA')"><i class="ph-eye me-1"></i>Non sommare</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_ESCLUDI_FEE_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Escludi dalla fee di progetto: la vendita non partecipa al calcolo della fee"
									@click="toggleFlag('FLG_ESCLUDI_FEE_VENDITA')"><i class="ph-percent me-1"></i>No fee</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_NETTO_IVA_VENDITA == 1 ? 'btn-primary' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sulla vendita, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_VENDITA')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-danger mb-1 mt-2"><i class="ph-shopping-cart me-1"></i><Translate :path="'dizionario.attivita.ACQUISTO'"></Translate></h6>
					<div class="row mb-2">
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.QTA'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.QUANTITY_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.RIP'"></Translate></label>
							<input type="number" step="1" class="form-control form-control-sm"
								v-model.number="vocePreferitaSelezionata.DAYS_COST_ESPOSTO" placeholder="1"
								@input="calcolaTotaleCostoEsposto()"
								@keypress="(e) => { if(e.key == '.' || e.key == ',') e.preventDefault(); }">
						</div>
						<div class="col-6 col-costo-voce">
							<label class="form-label fw-semibold mb-1 text-nowrap" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COSTO_ACQ'"></Translate>
								<i class="ph-gift cursor-pointer float-end" :class="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'text-success' : 'text-muted'" @click="toggleOmaggio('UNIT_COST_ESPOSTO')" :title="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? 'Omaggio attivo: clicca per disattivare' : 'Clicca per impostare come omaggio'"></i>
							</label>
							<div class="position-relative">
							<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="vocePreferitaSelezionata.UNIT_COST_ESPOSTO" placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1"
									@input="calcolaTotaleCostoEsposto()"
								@blur="vocePreferitaSelezionata.UNIT_COST_ESPOSTO = parseFloat(vocePreferitaSelezionata.UNIT_COST_ESPOSTO || 0).toFixed(2)">
						</div>
						</div>
						<div class="col-6 col-iva-voce">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA'"></Translate></label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_COSTO" :disabled="vocePreferitaSelezionata.FLG_NETTO_IVA_ACQUISTO == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md-1">
							<label class="form-label mb-1 text-nowrap" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA'"></Translate> ({{ ivaAcquistoSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaAcquistoSommario.importo" disabled>
						</div>
						<div class="col-6 col-md-2">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="vocePreferitaSelezionata.FLG_NETTO_IVA_ACQUISTO == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_ACQ_CON_IVA'"></Translate></label>
							<div class="position-relative">
							<input type="text" class="form-control form-control-sm bg-light text-danger fw-bold"
									:value="vocePreferitaSelezionata.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1 ? $root.translate('dizionario.attivita.OMAGGIO') : ivaAcquistoSommario.totale" readonly>
						</div>
							</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_ESCLUDI_TOTALE_ACQUISTO == 1 ? 'btn-danger' : 'btn-light'"
									title="Non sommare: acquisto e commissioni restano visibili ma non entrano nei totali di attività e progetto"
									@click="toggleFlag('FLG_ESCLUDI_TOTALE_ACQUISTO')"><i class="ph-eye me-1"></i>Non sommare</button>
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_NETTO_IVA_ACQUISTO == 1 ? 'btn-danger' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sull'acquisto, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_ACQUISTO')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>

					<h6 class="fw-semibold text-warning mb-1 mt-2"><i class="ph-handshake me-1"></i><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></h6>
					<div class="row">
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;"><Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate></label>
							<select class="form-select form-select-sm" v-model="vocePreferitaSelezionata.FK_ID_IVA_COMMISSIONI" :disabled="vocePreferitaSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1">
								<option :value="null">— Nessuna —</option>
								<option
									v-for="c in filters.getCodiciIvaAttivi()"
									:key="c.ID_OPZIONE_TIPOLOGICA"
									:value="c.ID_OPZIONE_TIPOLOGICA"
								>
									{{ c.CUSTOM_1 }} – {{ c.DESCRIZIONE }}
								</option>
							</select>
						</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></label>
							<div class="position-relative">
							<input type="number" step="0.01" class="form-control form-control-sm"
									v-model.number="vocePreferitaSelezionata.TOTAL_COST_PRIVATO" placeholder="0.00"
								:disabled="vocePreferitaSelezionata.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1"
								@blur="vocePreferitaSelezionata.TOTAL_COST_PRIVATO = parseFloat(vocePreferitaSelezionata.TOTAL_COST_PRIVATO || 0).toFixed(2)">
						</div>
							</div>
						<div class="col-6 col-md">
							<label class="form-label mb-1" style="font-size:0.85rem;">
								<Translate :path="'dizionario.attivita.IVA_COMMISSIONI'"></Translate> ({{ ivaCommissioniSommario.aliquota }}%)
							</label>
							<input type="text" class="form-control form-control-sm"
								:value="ivaCommissioniSommario.importo" disabled>
							</div>
						<div class="col-6 col-md">
							<label class="form-label fw-semibold mb-1" style="width:100%; font-size:0.85rem;"><Translate :path="vocePreferitaSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1 ? 'dizionario.attivita.TOTALE' : 'dizionario.attivita.TOTALE_COMM_CON_IVA'"></Translate></label>
							<input type="text" class="form-control form-control-sm bg-light text-warning fw-bold"
								:value="ivaCommissioniSommario.totale" disabled>
						</div>
						<div class="col-12 col-md">
							<label class="form-label mb-1 d-none d-md-block invisible" style="font-size:0.85rem;">&nbsp;</label>
							<div class="btn-group w-100">
								<button type="button" class="btn btn-sm text-nowrap" :class="vocePreferitaSelezionata.FLG_NETTO_IVA_COMMISSIONI == 1 ? 'btn-warning' : 'btn-light'"
									title="Netto IVA: nessuna IVA calcolata sulle commissioni, il valore mostrato è il netto"
									@click="toggleFlag('FLG_NETTO_IVA_COMMISSIONI')"><i class="ph-receipt me-1"></i>Netto IVA</button>
							</div>
						</div>
					</div>
					</fieldset>
				</div>
				<div class="modal-footer py-2">
					<button type="button" class="btn btn-sm btn-link" data-bs-dismiss="modal"><Translate :path="'dizionario.base.BTN_ANNULLA'"></Translate></button>
					<button v-if="!bloccato" type="button" class="btn btn-sm btn-secondary" @click="salvaVocePreferita(false)"
						:disabled="!vocePreferitaSelezionata.TITOLO || !vocePreferitaSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CHIUDI'"></Translate>
					</button>
					<button v-if="vocePreferitaSelezionata.ID_VOCE_PREFERITA == 0" type="button" class="btn btn-sm btn-primary" @click="salvaVocePreferita(true)"
						:disabled="!vocePreferitaSelezionata.TITOLO || !vocePreferitaSelezionata.QUANTITY_PRICE">
						<i class="ph-check me-1"></i>
						<Translate :path="'dizionario.base.BTN_SALVA_CONTINUA'"></Translate>
					</button>
				</div>
			</div>
		</div>
	</div>

	<SchedaAzienda ref="schedaAziendaFornitore" :tipo="2" @aziendaSalvata="onFornitoreCreato"></SchedaAzienda>

	<PopUpEsportazione id="popUpEsportazioneVociPreferite" @esporta="esportaDati" />
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue'
import Select2 from '@/components/utils/Select2.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
import ISort from '@/components/utils/ISort.vue'
import PopUpEsportazione from '@/components/common/PopUpEsportazione.vue'
import ColorPicker from '@/components/utils/ColorPicker.vue'
import SchedaAzienda from '@/components/SchedaAzienda.vue'

export default {
	name: "ConfVociPreferiteGenerali",

	components: {
		Pagine,
		Select2,
		ISwitch,
		ISort,
		PopUpEsportazione,
		ColorPicker,
		SchedaAzienda
	},

	data: function () {
		return {
			filters: global.filters,
			utils: global.utils,
			rs: utils.generateRandomString(30),
			esportazioneTipo: '',
			arrayVociPreferite: new Array(),
			vocePreferitaSelezionata: {},
			searchVociPreferite: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 25 },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				FK_ID_AZIENDA: { TYPE: 'COMBO', VALUE: '' },
				FK_ID_AZIENDA_FORNITORE: { TYPE: 'COMBO', VALUE: '' },
				FLG_ATTIVO: { TYPE: 'COMBO', VALUE: '' },
				FLG_ELIMINATO: { TYPE: 'COMBO', VALUE: '0' }
			},
			ordinamento: '',
			omaggioBackup: {},
			lock: null,
			lockHandle: null
		}
	},

	methods: {
		getVociPreferite: function (handler = null) {
			utils.get('theb/voci_preferite/lista', {}, (response) => {
				if (response.esito == 0) {
					this.arrayVociPreferite = response.data || [];
					// Emetti evento al parent per aggiornare i suoi dati
					this.$emit('update:vociPreferite', this.arrayVociPreferite);
					if (handler) handler();
				}
			});
		},

		voceVuota() {
			return {
				ID_VOCE_PREFERITA: 0,
				FK_ID_UTENTE: this.$root.utente.ID_UTENTE,
				FK_ID_AZIENDA: null,
				FK_ID_AZIENDA_FORNITORE: null,
				TITOLO: '',
				NOTE: '',
				COLORE: '#FFFFFF',
				COLORE_TESTO: null,
				QUANTITY_PRICE: 1,
				DAYS_PRICE: 1,
				QUANTITY_COST_ESPOSTO: 1,
				DAYS_COST_ESPOSTO: 1,
				UNIT_PRICE: 0,
				TOTAL_PRICE: 0,
				UNIT_COST_ESPOSTO: 0,
				TOTAL_COST_ESPOSTO: 0,
				UNIT_COST_PRIVATO: 0,
				TOTAL_COST_PRIVATO: 0,
				FK_ID_IVA_PREZZO: null,
				FK_ID_IVA_COSTO: null,
				FK_ID_IVA_COMMISSIONI: null,
				FLG_DA_CALCOLARE: 1,
				FLG_OMAGGIO_UNIT_PRICE: 0,
				FLG_OMAGGIO_UNIT_COST_ESPOSTO: 0,
				FLG_OMAGGIO_TOTAL_COST_PRIVATO: 0,
				FLG_ESCLUDI_TOTALE_VENDITA: 0,
				FLG_ESCLUDI_FEE_VENDITA: 0,
				FLG_NETTO_IVA_VENDITA: 1,
				FLG_ESCLUDI_TOTALE_ACQUISTO: 0,
				FLG_NETTO_IVA_ACQUISTO: 1,
				FLG_NETTO_IVA_COMMISSIONI: 1,
				FLG_PUBBLICO: 0,
				FLG_ATTIVO: 1,
				ORDINE: 0
			};
		},

		rilasciaLock() {
			utils.lock.release(this.lockHandle);
			this.lockHandle = null;
			this.lock = null;
		},

		nuovaVocePreferita: function () {
			this.vocePreferitaSelezionata = this.voceVuota();
			this.filters.openPopUp('popUpVocePreferita' + this.rs);
		},

		modificaVocePreferita: function (vp) {
			this.vocePreferitaSelezionata = utils.clone(vp);
			this.lockHandle = utils.lock.acquire('VOCE_PREFERITA', vp.ID_VOCE_PREFERITA, (stato) => this.lock = stato, () => this.getVociPreferite(() => {
				var v = utils.array.select(this.arrayVociPreferite, 'ID_VOCE_PREFERITA', vp.ID_VOCE_PREFERITA, 1)[0];
				if (v) this.vocePreferitaSelezionata = utils.clone(v);
			}));
			this.filters.openPopUp('popUpVocePreferita' + this.rs);
		},

		attivaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Attivare ' + sel.length + ' voci preferite?', () => {
				utils.put('theb/voci_preferite/attiva-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite attivate con successo.'); }
				});
			}, this.$root);
		},
		disattivaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Disattivare ' + sel.length + ' voci preferite?', () => {
				utils.put('theb/voci_preferite/disattiva-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite disattivate con successo.'); }
				});
			}, this.$root);
		},
		eliminaSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Eliminare ' + sel.length + ' voci preferite selezionate?', () => {
				utils.delete('theb/voci_preferite/delete-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite eliminate con successo.'); }
				});
			}, this.$root);
		},
		eliminaDefinitivamenteSelezionati() {
			var sel = utils.array.select(this.arrayVociPreferite, 'SELEZIONATO', 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita selezionata.'); return; }
			utils.alert.confirm('Eliminare DEFINITIVAMENTE ' + sel.length + ' voci preferite? Azione irreversibile.', () => {
				utils.delete('theb/voci_preferite/harddelete-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite eliminate definitivamente.'); }
				});
			}, this.$root);
		},
		ripristinaSelezionati() {
			var sel = this.arrayVociPreferite.filter(v => v.SELEZIONATO == 1 && v.FLG_ELIMINATO == 1);
			if (sel.length == 0) { utils.alert.warning('Nessuna voce preferita eliminata selezionata.'); return; }
			utils.alert.confirm('Ripristinare ' + sel.length + ' voci preferite?', () => {
				utils.put('theb/voci_preferite/ripristina-bulk', { IDS: sel.map(v => v.ID_VOCE_PREFERITA) }, (r) => {
					if (r.esito == 0) { this.getVociPreferite(); utils.alert.success('Voci preferite ripristinate con successo.'); }
				});
			}, this.$root);
		},
		ripristinaVocePreferita(vp) {
			utils.put('theb/voci_preferite/ripristina', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
				if (r.esito == 0) {
					this.getVociPreferite();
					utils.alert.success('Voce preferita ripristinata con successo.');
					utils.notifiche.invia(this, 'VOCE_PREFERITA_MODIFICA', 'ha ripristinato la voce preferita "' + vp.TITOLO + '"');
				}
			});
		},
		eliminaVocePreferita(vp) {
			utils.alert.confirm(`Eliminare la voce preferita "${vp.TITOLO}"?`, () => {
				utils.delete('theb/voci_preferite/delete', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
					if (r.esito == 0) {
						this.getVociPreferite();
						utils.alert.success('Voce preferita eliminata con successo.');
						utils.notifiche.invia(this, 'VOCE_PREFERITA_ELIMINA', 'ha eliminato la voce preferita "' + vp.TITOLO + '"');
					}
				});
			}, this.$root);
		},
		eliminaDefinitivamenteVocePreferita(vp) {
			utils.alert.confirm(`Eliminare DEFINITIVAMENTE "${vp.TITOLO}"? Azione irreversibile.`, () => {
				utils.delete('theb/voci_preferite/harddelete', { ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA }, (r) => {
					if (r.esito == 0) {
						this.getVociPreferite();
						utils.alert.success('Voce preferita eliminata definitivamente.');
					}
				});
			}, this.$root);
		},

		toggleFlgAttivo: function (vp, newValue) {
			utils.put('theb/voci_preferite/update', {
				ID_VOCE_PREFERITA: vp.ID_VOCE_PREFERITA,
				FLG_ATTIVO: newValue
			}, (response) => {
				if (response.esito == 0) {
					this.getVociPreferite();
				}
			});
		},

		salvaVocePreferita: function (continua = false) {
			const v = this.vocePreferitaSelezionata;
			if (!v.TITOLO || v.TITOLO.trim() == '') { utils.alert.warning('Il titolo è obbligatorio'); return; }
			if (!v.QUANTITY_PRICE || v.QUANTITY_PRICE < 1) { utils.alert.warning('La quantità (Prezzo) deve essere almeno 1'); return; }
			if (!v.DAYS_PRICE || v.DAYS_PRICE < 1) { utils.alert.warning('Le ripetizioni (Prezzo) devono essere almeno 1'); return; }
			if (!v.QUANTITY_COST_ESPOSTO || v.QUANTITY_COST_ESPOSTO < 1) { utils.alert.warning('La quantità (Costo Esposto) deve essere almeno 1'); return; }
			if (!v.DAYS_COST_ESPOSTO || v.DAYS_COST_ESPOSTO < 1) { utils.alert.warning('Le ripetizioni (Costo Esposto) devono essere almeno 1'); return; }
			this.calcolaTotalePrezzo();
			this.calcolaTotaleCostoEsposto();
			const isUpdate = this.vocePreferitaSelezionata.ID_VOCE_PREFERITA > 0;
			const endpoint = isUpdate ? 'theb/voci_preferite/update' : 'theb/voci_preferite/insert';
			(isUpdate ? utils.put : utils.post)(endpoint, this.vocePreferitaSelezionata, (response) => {
				if (response.esito == 0) {
					this.getVociPreferite();
					utils.alert.success('Voce preferita salvata con successo!');
					utils.notifiche.invia(this, endpoint.includes('insert') ? 'VOCE_PREFERITA_CREA' : 'VOCE_PREFERITA_MODIFICA', (endpoint.includes('insert') ? 'ha creato la voce preferita "' : 'ha modificato la voce preferita "') + this.vocePreferitaSelezionata.TITOLO + '"');
					if (continua) {
						this.vocePreferitaSelezionata = this.voceVuota();
					} else {
						this.filters.closePopUp('popUpVocePreferita' + this.rs);
					}
				} else {
					utils.alert.warning('Errore: ' + response.messaggio);
				}
			});
		},

		apriEsportazione: function(tipo) {
			this.esportazioneTipo = tipo;
			this.filters.openPopUp('popUpEsportazioneVociPreferite');
		},

		esportaDati: function(formato) {
			utils.esportaTabella({
				tipo:          this.esportazioneTipo,
				formato:       formato,
				arrayCompleto: this.arrayVociPreferite,
				arrayPagina:   this.paginatedListVociPreferite.arr,
				idField:       'ID_VOCE_PREFERITA',
				modulo:        'vociPreferite',
				nomeFile:      'voci_preferite'
			});
		},

		toggleFlag(field) {
			this.vocePreferitaSelezionata[field] = this.vocePreferitaSelezionata[field] == 1 ? 0 : 1;
		},

		toggleOmaggio(field) {
			const v = this.vocePreferitaSelezionata;
			const flagField = `FLG_OMAGGIO_${field}`;
			const isOmaggio = v[flagField] == 1;
			v[flagField] = isOmaggio ? 0 : 1;
			if (!isOmaggio) {
				this.omaggioBackup[field] = v[field];
				v[field] = 0;
			} else {
				v[field] = this.omaggioBackup[field] ?? 0;
			}
			if (field == 'UNIT_COST_ESPOSTO') this.calcolaTotaleCostoEsposto();
			else if (field == 'UNIT_PRICE') this.calcolaTotalePrezzo();
		},

		calcolaTotalePrezzo() {
			const v = this.vocePreferitaSelezionata;
			v.QUANTITY_PRICE = parseInt(v.QUANTITY_PRICE) || 0;
			v.DAYS_PRICE = parseInt(v.DAYS_PRICE) || 1;
			v.TOTAL_PRICE = ((parseFloat(v.UNIT_PRICE) || 0) * v.QUANTITY_PRICE * v.DAYS_PRICE).toFixed(2);
		},

		calcolaTotaleCostoEsposto() {
			const v = this.vocePreferitaSelezionata;
			v.QUANTITY_COST_ESPOSTO = parseInt(v.QUANTITY_COST_ESPOSTO) || 0;
			v.DAYS_COST_ESPOSTO = parseInt(v.DAYS_COST_ESPOSTO) || 1;
			v.TOTAL_COST_ESPOSTO = ((parseFloat(v.UNIT_COST_ESPOSTO) || 0) * v.QUANTITY_COST_ESPOSTO * v.DAYS_COST_ESPOSTO).toFixed(2);
		},

		apriNuovoFornitore() {
			this.$refs.schedaAziendaFornitore.openSchedaAzienda({ ID_AZIENDA: 0, personaGiuridica: {} });
		},

		onFornitoreCreato(azienda) {
			this.$refs.schedaAziendaFornitore.chiudi();
			if (azienda?.ID_AZIENDA > 0) {
				this.vocePreferitaSelezionata.FK_ID_AZIENDA_FORNITORE = azienda.ID_AZIENDA;
			}
		},

		getIvaCode(fkId) {
			return this.filters.getIvaCodeById(fkId);
		},

		sommarioIva(totale, fkIva, flgNetto) {
			const prezzo = parseFloat(totale) || 0;
			if (flgNetto == 1) return { aliquota: 0, importo: '0.00', totale: this.vocePreferitaSelezionata.ID_VOCE_PREFERITA > 0 ? prezzo.toFixed(2) : '' };
			const codiceIva = this.filters.getIvaCodeById(fkIva);
			const { aliquota, tipo } = this.filters.parseCodiceIva(codiceIva);
			const importo = this.filters.calcolaImportoIva(prezzo, codiceIva);
			return { aliquota, importo: importo.toFixed(2), totale: (tipo == 'esclusa' ? prezzo + importo : prezzo).toFixed(2) };
		}
	},

	computed: {
		bloccato() { return this.lock != null && !this.lock.MIO; },
		paginatedListVociPreferite() {
			var arr = utils.inGrid(this.arrayVociPreferite, this.searchVociPreferite, this.ordinamento);
			return arr;
		},

		coloreTestoAutomaticoVoce: {
			get() {
				return !this.vocePreferitaSelezionata.COLORE_TESTO;
			},
			set(val) {
				this.vocePreferitaSelezionata.COLORE_TESTO = val ? null : (this.utils.getContrastColor(this.vocePreferitaSelezionata.COLORE) || '#000000');
			},
		},

		ivaModaleSommario() {
			return this.sommarioIva(this.vocePreferitaSelezionata.TOTAL_PRICE, this.vocePreferitaSelezionata.FK_ID_IVA_PREZZO, this.vocePreferitaSelezionata.FLG_NETTO_IVA_VENDITA);
		},

		ivaAcquistoSommario() {
			return this.sommarioIva(this.vocePreferitaSelezionata.TOTAL_COST_ESPOSTO, this.vocePreferitaSelezionata.FK_ID_IVA_COSTO, this.vocePreferitaSelezionata.FLG_NETTO_IVA_ACQUISTO);
		},

		ivaCommissioniSommario() {
			return this.sommarioIva(this.vocePreferitaSelezionata.TOTAL_COST_PRIVATO, this.vocePreferitaSelezionata.FK_ID_IVA_COMMISSIONI, this.vocePreferitaSelezionata.FLG_NETTO_IVA_COMMISSIONI);
		}
	},

	mounted: function () {
		this.getVociPreferite();
		document.getElementById('popUpVocePreferita' + this.rs).addEventListener('hidden.bs.modal', () => this.rilasciaLock());
	},

	beforeUnmount() {
		this.rilasciaLock();
	},
	
}
</script>

<style scoped>
/* come popUpVoce in Attivita.vue */
@media (min-width: 768px){.col-costo-voce{flex:0 0 auto;width:11.5%}.col-iva-voce{flex:0 0 auto;width:13.5%}}

/* come VoceNode: VENDITA cols 4–7, ACQUISTO cols 8–11 */
tbody tr td:nth-child(n+3):nth-child(-n+7) {
	border-left: 1px solid #e8e8e8 !important;
	border-right: 1px solid #e8e8e8 !important;
}

tbody tr td:nth-child(n+8):nth-child(-n+11) {
	border-left: 1px solid #FFD648 !important;
	border-right: 1px solid #FFD648 !important;
}

/* Bordo spesso tra VENDITA e ACQUISTO */
thead tr:first-child th:nth-child(4),
thead tr:last-child th:nth-child(4),
tbody tr td:nth-child(7) {
	border-right: 20px solid white !important;
}

thead tr:first-child th:nth-child(5),
thead tr:last-child th:nth-child(5),
tbody tr td:nth-child(8) {
	border-left: 20px solid white !important;
}
</style>
